// extracted by mini-css-extract-plugin
export default {"emote":"_17SNN","not-official":"yxc04","notOfficial":"yxc04","title":"_2QIz8","emote-pixel":"_1Ts0e","emotePixel":"_1Ts0e"};